export default function CaDownloadAnswerIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00469 4.5V10.8M9.00469 10.8L11.7047 8.1M9.00469 10.8L6.30469 8.1"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5984 13.5H5.39844"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M16.1514 16.151L16.1508 16.1515C15.6551 16.6479 14.9803 16.9382 13.838 17.0919C12.6741 17.2484 11.1425 17.25 9 17.25C6.85749 17.25 5.32608 17.2484 4.16223 17.0919C3.01999 16.9383 2.34465 16.6479 1.84793 16.1512L1.84775 16.151C1.35176 15.6553 1.06156 14.9805 0.908017 13.8381C0.751592 12.6742 0.75 11.1425 0.75 9C0.75 6.85751 0.751592 5.32606 0.908017 4.16216C1.06151 3.02006 1.35164 2.34471 1.84781 1.84805C2.34503 1.35164 3.02056 1.06151 4.16251 0.908016C5.32628 0.751592 6.8575 0.75 9 0.75C11.1425 0.75 12.6739 0.751592 13.8377 0.908016C14.9799 1.06154 15.655 1.35174 16.1512 1.84793C16.648 2.34517 16.9383 3.02067 17.0919 4.16258C17.2484 5.32631 17.25 6.85749 17.25 9C17.25 11.1425 17.2484 12.6739 17.0919 13.8376C16.9383 14.9798 16.6479 15.6548 16.1514 16.151Z"
        stroke="black"
        stroke-width="1.5"
      />
    </svg>
  );
}
